<template>
  <layout-default-appbar filterable
    :filters="filters">
    Pedido
  </layout-default-appbar>
</template>

<script>
import { PRODUTO_QUERIES } from '@/constants/QUERY_FILTERS';

import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';

export default {
  name: 'ViewPedidoAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {

      filters: [
        PRODUTO_QUERIES.createdFrom,
        PRODUTO_QUERIES.createdBefore,
      ],
    };
  },
};
</script>
